import { UserTaskMimshakData, UserTaskType } from "../../interfaces/DTO/userTask/UserTask";
import {
  DailyReportAction,
  DailyReportComparison,
  DailyReportLinkedTask,
  DailyReportUploadResult,
} from "../../interfaces/DTO/userTask/dailyReport";
import { MimshakDataService } from "../mimshakDataService";


export class UserTaskMimshakDataService extends MimshakDataService {
  // The user-task router's /by_user_sorted is still user-based (legacy) and takes user_ids
  protected sortedIdsQueryParam = "user_ids";

  constructor(apiUrl: string = "/user_task_mimshak_data") {
    super(apiUrl);
  }
// ✅ העלאת קובץ דוח יומי – מחזיר מה זוהה (יצרן, תאריך) ומה דורש תשומת לב
async uploadDailyTrackReport(file: File): Promise<DailyReportUploadResult> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await this.apiClient.post<DailyReportUploadResult>(
      `${this.API_URL}/upload-daily-track-report`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  }
  /** הפעולות המדווחות של כל הלקוחות – האחרונות שנראו קודם. seenSince (ISO) – רק מה שנראה מאז (ההעלאה האחרונה) */
  async getReportedActions(seenSince?: string): Promise<DailyReportAction[]> {
    const response = await this.apiClient.get<DailyReportAction[]>(`${this.API_URL}/actions`, {
      params: seenSince ? { seen_since: seenSince } : {},
    });
    return response.data;
  }

  /** הפעולות המדווחות של אנשי הקשר האלה בלבד (מסך של לקוח / משפחה) – לעולם לא של כל הלקוחות */
  async getReportedActionsForContacts(contactIds: number[]): Promise<DailyReportAction[]> {
    if (contactIds.length === 0) throw new Error("contactIds is required");
    const params = new URLSearchParams();
    contactIds.forEach((id) => params.append("contact_ids", id.toString()));
    const response = await this.apiClient.get<DailyReportAction[]>(`${this.API_URL}/actions/by-contacts?${params.toString()}`);
    return response.data;
  }

  /** לפני / השינוי / אחרי של פעולה מדווחת – מנתוני המסלקה בתקופות המתאימות */
  async getActionComparison(actionId: number): Promise<DailyReportComparison> {
    const response = await this.apiClient.get<DailyReportComparison>(`${this.API_URL}/actions/${actionId}/comparison`);
    return response.data;
  }

  /** משימות קיימות שהפעולה יכולה להשתייך אליהן (לא קושרו אוטומטית – יותר מאחת) */
  async getActionTaskCandidates(actionId: number): Promise<DailyReportLinkedTask[]> {
    const response = await this.apiClient.get<DailyReportLinkedTask[]>(`${this.API_URL}/actions/${actionId}/task-candidates`);
    return response.data;
  }

  /** פתיחת משימה לפעולה מדווחת שאין לה, וקישור אליה */
  async createActionTask(actionId: number, title?: string): Promise<DailyReportLinkedTask> {
    const response = await this.apiClient.post<DailyReportLinkedTask>(`${this.API_URL}/actions/${actionId}/task`, { title });
    return response.data;
  }

  /** קישור פעולה מדווחת למשימה קיימת של אותו לקוח */
  async linkActionTask(actionId: number, taskId: number): Promise<DailyReportLinkedTask> {
    const response = await this.apiClient.post<DailyReportLinkedTask>(`${this.API_URL}/actions/${actionId}/task/${taskId}`);
    return response.data;
  }

  async getAllUserTasks(): Promise<UserTaskMimshakData[]> {
    try {
      const response = await this.apiClient.get<UserTaskMimshakData[]>(`${this.API_URL}/all`);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch user tasks:", error);
      throw error;
    }
  }
}

export const userTaskMimshakDataService = new UserTaskMimshakDataService();
